export default "__VITE_ASSET__taMucGCm__"